<script setup>
import { computed } from 'vue'
import { usePrintTemplates } from '@/composables/print-template'

import PrintTemplateThumbnail from '@/components/accounting/PrintTemplateThumbnail.vue'

const props = defineProps({
  modelValue: {
    type: Number,
    required: false,
    default: null,
  },
  documentType: {
    type: Number,
    required: true,
  },
  disable: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const { selectableTemplates } = usePrintTemplates()
const options = computed(() => selectableTemplates(props.modelValue))
</script>
<template>
  <div class="print-template-strip row no-wrap q-gutter-sm q-pb-sm">
    <button
      v-for="template in options"
      :key="template.id"
      type="button"
      class="print-template-strip-item column items-center"
      :class="{ selected: template.id === modelValue }"
      :disabled="disable"
      :title="template.name"
      @click="template.id !== modelValue && emit('update:modelValue', template.id)"
    >
      <print-template-thumbnail :template="template" :document-type="documentType" />
      <span class="ellipsis full-width text-center">{{ template.name }}</span>
    </button>
  </div>
</template>
<style scoped lang="scss">
.print-template-strip {
  max-width: 100%;
  overflow-x: auto;
}

.print-template-strip-item {
  flex: 0 0 4.5rem;
  min-width: 0;
  gap: .25rem;
  padding: .25rem;
  border: .125rem solid transparent;
  border-radius: .3125rem;
  background-color: $grey-2;
  font-size: .6875rem;
  color: $grey-8;
  cursor: pointer;

  &.selected {
    border-color: $primary;
    color: $primary;
    font-weight: 500;
  }

  &:disabled {
    cursor: not-allowed;

    &:not(.selected) {
      opacity: .45;
    }
  }
}
</style>
